export const desafiosEnum = {
    quiz: '88fe5800-d716-4143-a270-29b5b12e3fcd',
    janelaTanque: '42cdecfc-c297-491a-902e-35565506413b',
}

export const urlDesafio  = {
    [desafiosEnum.janelaTanque]: ''
}